var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finish-wrap"},[(_vm.type == 'index')?_c('div',{staticClass:"finish-text"},[_vm._v("您已提交问卷，感谢您的参与!")]):_vm._e(),(_vm.type == 'survey')?_c('div',{staticClass:"finish-text"},[_vm._v("问卷已提交，感谢您的参与!")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }